// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1NvbH","list":"BalanceDue_list__106Cf","listRow":"BalanceDue_listRow__qRbVg","total":"BalanceDue_total__1TibN"};